import { render, staticRenderFns } from "./SalesCRMReports.vue?vue&type=template&id=66b05e65&scoped=true"
import script from "./SalesCRMReports.vue?vue&type=script&lang=js"
export * from "./SalesCRMReports.vue?vue&type=script&lang=js"
import style0 from "./SalesCRMReports.vue?vue&type=style&index=0&id=66b05e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b05e65",
  null
  
)

export default component.exports